export enum PushNotificationIdentity {
  Moment = 'moment',
  Exercise = 'exercise',
  FirstMeeting = 'first-meeting',
  NoFirstMeeting = 'no-first-meeting',
  WelcomeAfterSuccessfulPayment = 'welcome-after-successful-payment',
  RegularChatMessage = 'regular-chat-message',
  RegularChatDmMessage = 'regular-chat-dm-message',
  SegmentForumMention = 'segment-forum-mention',
  SendMessageToExpert = 'send-message-to-expert',
  MessageFromBrazeWebhook = 'message-from-braze-webhook',
  NotSpecified = 'not-specified',
  CirclesBot = 'circles-bot',
  SessionAgendaContent = 'session-agenda-content',
}

export interface PushNotificationAnalytics {
  pushNotificationIdentity: PushNotificationIdentity | string;
  privateChat?: boolean;
  sender?: string;
  groupInstanceId?: string;
}

export type NotificationPayload = {
  avatar?: string;
  navTo?: string;
  navParams?: any;
  apiCall?: {
    store: string;
    call: string;
    params?: any;
  };
  analytics?: any;
  externalLink?: string;
};
